import {Employer} from './../models/Employer';
import {AsyncResult} from 'Core/models/Async';
import {Page} from 'Core/models/Page';
import {
  HistoryApi,
  HistoryDetailsApi,
  ProcessingHistoryApi,
  EnrollmentApi,
  EnrollmentDiscrepancyDetailApi,
  EmailHistoryApi,
  GenelcoBatchFileApi,
} from 'Enrollment/api';
import {EmployerEnrollmentFilters} from 'Enrollment/ducks/employerEnrollment';
import {
  EnrollmentApplicationsFilters,
  EnrollmentFileFilters,
  EnrollmentApplicationDetailFilters,
  ExternalUploadQueueFilters,
  EnrollmentApplicationErrorDetailFilters,
  ApplicationsFilter,
  EmployerProfileUploadFilters,
  ExternalUploadQueueDetailsFilters,
} from 'Enrollment/ducks/enrollmentFileProcessing';
import {
  EnrollmentFileRejectFilters,
  EnrollmentFileRejectDetailsFilters,
  EnrollmentFileRejectEmailHistoryFilters,
} from 'Enrollment/ducks/enrollmentFileProcessingReject';
import {EnrollmentFilesNotProcessedFilters} from 'Enrollment/ducks/enrollmentFilesNotProcessed';
import {EmployerEnrollment} from 'Enrollment/models/EmployerEnrollment';
import {EmployerEnrollmentDetails} from 'Enrollment/models/EmployerEnrollmentDetails';
import {EnrollmentApplication} from 'Enrollment/models/EnrollmentApplication';
import {EmployerProfileDetails} from 'Enrollment/models/EmployerProfileDetails';
import {EnrollmentFile} from 'Enrollment/models/EnrollmentFile';
import {EnrollmentFileDetails} from 'Enrollment/models/EnrollmentFileDetails';
import {EnrollmentFileNotes} from 'Enrollment/models/EnrollmentFileNotes';
import {EnrollmentFileReject} from 'Enrollment/models/EnrollmentFileReject';
import {EnrollmentFileRejectsSendEmail} from 'Enrollment/models/EnrollmentFileRejectsSendEmail';
import {EnrollmentFileAuditDetail} from 'Enrollment/models/EnrollmentFileAuditDetail';
import {
  AccountProfileMetricsPayload,
  FileProfileMetricsPayload,
  FileTrackingMonitorMetricsPayload,
  EnrollmentMetricsPayload,
  FileFeedbackMetricsPayload,
  FilesNotProcessedMetricsPayload,
  OverallEnrollmentMetricsPayload,
} from 'Enrollment/models/EnrollmentMetricsPayload';
import {PendingEnrollmentFileStatus} from 'Enrollment/models/EnrollmentFilesNotProcessed';
import {GenelcoBatchFileCommand} from 'Enrollment/models/GenelcoBatchFileCommand';
import {addFilterParameters} from 'Shared/utilities/addFilterParameters';
import axiosInstance from 'Shared/utilities/axiosInstance';
import {
  get,
  getAxiosConfig,
  handleResponse,
  post,
  postMultipart,
  withCancellation,
} from 'Shared/utilities/fetchHelpers';
import {AWDHistoryDetail} from '../models/AWDStatusDetails';
import {EnrollmentFileStatus, EnrollmentFilesNotProcessed} from '../models/EnrollmentFilesNotProcessed';
import {ApplicationProcessingDetail} from '../models/ESRBPStatusDetails';
import {EnrollmentApplicationTemplate} from 'Enrollment/models/EnrollmentApplicationTemplate';
import {AgreementAcknowledgment} from 'Enrollment/models/AgreementAcknowledgment';
import {EnrollmentFileRecordValidationResult} from 'Enrollment/models/EnrollmentFileRecordValidationResult';
import {LifeCycleReportChartDetailsPayload} from 'Enrollment/models/LifeCycleReportChartDetailsPayload';
import {ProcessingAccuracyChartDetailsPayload} from 'Enrollment/models/ProcessingAccuracyChartDetailsPayload';
import {EnrollmentFileApplicationDetail} from 'Enrollment/models/EnrollmentFileApplicationDetails';
import {DaysToCompleteTurnAroundChartDetailsPayload} from 'Enrollment/models/DaysToCompleteTurnAroundChartDetailsPayload';
import {TotalRecordsChartDetailsPayload} from 'Enrollment/models/TotalRecordsChartDetailsPayload';
import {ExternalUploadEnrollmentApplication} from 'Enrollment/models/ExternalUploadEnrollmentApplication';
import {Sort, toSortQuerystringParams} from 'Shared/components/PagedView/Table/Sort';
import {RejectHistoryDetail} from 'Enrollment/models/RejectHistoryDetail';
import {EnrollmentFileRejectApplication} from 'Enrollment/models/EnrollmentFileRejectApplication';
import {FileUploadInProgress} from 'Enrollment/models/FileUploadInProgress';
import {BrokerSpreadsheetUploadsMetrics} from 'Enrollment/models/BrokerSpreadsheetsUploadsMetrics';
import {EnrollmentFileErrorDetails} from 'Enrollment/models/EnrollmentFileErrorDetails';
import {EnrollmentFileRejectEmailHistory} from 'Enrollment/models/EnrollmentFileRejectEmailHistory';
import {Application} from 'Enrollment/models/Application';
import {GetRejectEmailRequestDto} from 'Enrollment/models/GetRejectEmailRequest';
import {CancelTokenSource} from 'axios';
import {GenelcoBatchFileFilters} from 'Enrollment/ducks/genelcoBatchFileManagement';
import {GenelcoBatchFile} from 'Enrollment/models/GenelcoBatchFile';
import {EmployerProfileHistoryApi, EnrollmentFilesHistoryApi} from './api';
import { ExternalUploadEnrollmentApplicationDetails } from 'Enrollment/models/ExternalUploadEnrollmentApplicationDetails';

const enrollmentFileRejectsDetailsApi = new HistoryDetailsApi(
  undefined,
  process.env.REACT_APP_BASE_GATEWAY_URL,
  axiosInstance
);
const enrollmentFileRejectsApi = new HistoryApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);
const enrollmentFileApi = new ProcessingHistoryApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);
const enrollmentApi = new EnrollmentApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);
const enrollmentFileHistoryApi = new EnrollmentFilesHistoryApi(
  undefined,
  process.env.REACT_APP_BASE_GATEWAY_URL,
  axiosInstance
);
const enrollmentDetailsApi = new EnrollmentDiscrepancyDetailApi(
  undefined,
  process.env.REACT_APP_BASE_GATEWAY_URL,
  axiosInstance
);
const enrollmentFileRejectEmailApi = new EmailHistoryApi(
  undefined,
  process.env.REACT_APP_BASE_GATEWAY_URL,
  axiosInstance
);
const genelcoBatchFileApi = new GenelcoBatchFileApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);
const employerProfileHistoryApi = new EmployerProfileHistoryApi(
  undefined,
  process.env.REACT_APP_BASE_GATEWAY_URL,
  axiosInstance
);

export const enrollmentFileRootUri = '/enrollmentFiles';
export const enrollmentFilesNotProcessedRootUri = '/enrollmentFiles/processingHistory/pending';
export const enrollmentFileApplicationRootUri = '/enrollmentFiles/applicationstatus/esr';
export const enrollmentFileApplicationProcessingRootUri = '/enrollmentFiles/applicationprocessing/esr';
export const enrollmentFileUploadRootUri = '/orchestration';
export const enrollmentFileAWDHistoryRootUri = '/enrollmentFiles/history/awd';
export const documentsRootUri = '/documents';

export default {
  getOverallEnrollmentMetrics: () =>
    get<OverallEnrollmentMetricsPayload>(`${enrollmentFileRootUri}/processingHistory/metrics`),

  getFileFeedbackMetrics: () => get<FileFeedbackMetricsPayload>(`${enrollmentFileRootUri}/fileFeedback/metrics`),

  getFilesNotProcessedMetrics: () =>
    get<FilesNotProcessedMetricsPayload>(`${enrollmentFileRootUri}/filesNotProcessed/metrics`),

  getEmwEnrollmentMetrics: () => get<EnrollmentMetricsPayload>(`${enrollmentFileRootUri}/processingHistory/emwMetrics`),

  getEsrEnrollmentMetrics: () => get<EnrollmentMetricsPayload>(`${enrollmentFileRootUri}/processingHistory/eseMetrics`),

  getFileProfileMetrics: () =>
    get<FileProfileMetricsPayload>(`${enrollmentFileRootUri}/fileProfile/metrics`),
  getAccountProfileMetrics: () =>
    get<AccountProfileMetricsPayload>(
      `${enrollmentFileRootUri}/accountProfile/metrics`
    ),
  getFileTrackingMonitorMetrics: () =>
    get<FileTrackingMonitorMetricsPayload>(
      `${enrollmentFileRootUri}/fileTrackingMonitor/metrics`
    ),

  getEnrollmentFiles: (filter?: EnrollmentFileFilters) =>
    get<Page<EnrollmentFile>>(`${enrollmentFileRootUri}/processingHistory/emw/${addFilterParameters(filter)}`),
  getEnrollmentFileDetails: (id: string) =>
    get<EnrollmentFileDetails>(`${enrollmentFileRootUri}/processingHistory/${id}/details`),

  getEmwEnrollmentFiles: (filter?: EnrollmentFileFilters) =>
    get<Page<EnrollmentFile>>(`${enrollmentFileRootUri}/processingHistory/emw/${addFilterParameters(filter)}`),
  getEmwEnrollmentFileDetails: (id: string) =>
    get<EnrollmentFileDetails>(`${enrollmentFileRootUri}/processingHistory/emw/${id}/details`),

  getEsrEnrollmentFiles: (filter?: EnrollmentFileFilters) =>
    get<Page<EnrollmentFile>>(`${enrollmentFileRootUri}/processingHistory/esr/${addFilterParameters(filter)}`),
  getEsrEnrollmentFileDetails: (id: string) =>
    get<EnrollmentFileDetails>(`${enrollmentFileRootUri}/processingHistory/esr/${id}/details`),

  getEsrEnrollmentFileDetailsByCaseRequestId: (caseRequestId: string) =>
    get<EnrollmentFileDetails>(`${enrollmentFileRootUri}/processingHistory/esr/${caseRequestId}/detail`),

  getEnrollmentFileRejects: (filter?: EnrollmentFileRejectFilters, sort?: Sort) =>
    withCancellation(cancelToken =>
      enrollmentFileRejectsApi
        .historyGet('1', {
          params: {...filter, ...(sort && toSortQuerystringParams(sort))},
          ...getAxiosConfig(cancelToken, false),
        })
        .then(handleResponse)
        .then(value => value as AsyncResult<Page<EnrollmentFileReject>>)
    ),

  getEnrollmentFileRejectDetails: (id: string, applicationSource: string) =>
    withCancellation(cancelToken =>
      enrollmentFileRejectsDetailsApi
        .historyDetailsGetEnrollmentFileRejectDetailsByCaseRequestId(id, applicationSource, '1', {
          ...getAxiosConfig(cancelToken, false),
        })
        .then(handleResponse)
        .then(value => value as AsyncResult<RejectHistoryDetail>)
    ),

  getEnrollmentFileRejectDetailsApplications: (
    id: string,
    applicationSource: string,
    filter?: EnrollmentFileRejectDetailsFilters,
    sort?: Sort
  ) =>
    withCancellation(cancelToken =>
      enrollmentFileRejectsDetailsApi
        .historyDetailsGetEnrollmentFileRejectDetailsApplications(id, applicationSource, '1', {
          params: {...filter, ...(sort && toSortQuerystringParams(sort))},
          ...getAxiosConfig(cancelToken, false),
        })
        .then(handleResponse)
        .then(value => value as AsyncResult<Page<EnrollmentFileRejectApplication>>)
    ),

  getEnrollmentFileRejectEmailHistory: (
    id: string,
    applicationSource: string,
    filter?: EnrollmentFileRejectEmailHistoryFilters
  ) =>
    withCancellation(cancelToken =>
      enrollmentFileRejectEmailApi
        .emailHistoryGetEmailHistory(id, applicationSource, '1', {
          params: filter,
          ...getAxiosConfig(cancelToken, false),
        })
        .then(handleResponse)
        .then(value => value as AsyncResult<Page<EnrollmentFileRejectEmailHistory>>)
    ),

  getEnrollmentFileNotes: (fileName: string) =>
    get<EnrollmentFileNotes[]>(`${enrollmentFileRootUri}/fileprofile/${fileName}/notes`),

  getEnrollmentFileRejectsEmail: (rejectFile: GetRejectEmailRequestDto) =>
    withCancellation(cancelToken =>
      enrollmentFileRejectEmailApi
        .emailHistoryGetEmail('1', rejectFile, {
          ...getAxiosConfig(cancelToken, false),
        })
        .then(handleResponse)
    ),

  auditEnrollmentFileRejectsEmailAttachmentDownload: (caseRequestID: string) => 
    post<string>(`${enrollmentFileRootUri}/processingHistory/rejects/${caseRequestID}/email/audit/attachment`),

  sendEnrollmentFileRejectsEmail: (emailData: EnrollmentFileRejectsSendEmail) =>
    withCancellation(cancelToken =>
      enrollmentFileRejectEmailApi
        .emailHistorySendEmail('1', emailData, {
          ...getAxiosConfig(cancelToken, false),
        })
        .then(handleResponse)
    ),

  getEnrollmentFilesNotProcessedReports: (filter?: EnrollmentFilesNotProcessedFilters) =>
    withCancellation(cancelToken =>
      enrollmentFileApi
        .processingHistoryGet('1', {params: filter, ...getAxiosConfig(cancelToken, false)})
        .then(handleResponse)
        .then(value => value as AsyncResult<Page<EnrollmentFilesNotProcessed>>)
    ),

  getFileAndScheduleHistoryStatus: (data: PendingEnrollmentFileStatus) =>
    post<Page<EnrollmentFileStatus>>(`${enrollmentFilesNotProcessedRootUri}/details/`, data),

  getEnrollmentFileRejectFileProfile: (fileName: string) =>
    get<string>(`${enrollmentFileRootUri}/processingHistory/rejects/${fileName}/fileProfile`),

  getEnrollmentFileApplicationDetail: (filters?: EnrollmentApplicationDetailFilters) =>
    get<Page<EnrollmentFileApplicationDetail>>(
      `${enrollmentFileApplicationRootUri}/${addFilterParameters({
        ...filters,
      })}`
    ),

  getEnrollmentFileApplicationDetailById: (id: string, caseRequestId: string) =>
    get<EnrollmentFileDetails>(`${enrollmentFileApplicationRootUri}/${id}/detail?caseRequestId=${caseRequestId}`),

  getEnrollmentFileApplicationProcessingDetail: (id: string) =>
    get<ApplicationProcessingDetail>(`${enrollmentFileApplicationProcessingRootUri}/${id}/details`),

  uploadEnrollmentApplications: (
    file: File,
    applicationTypeId: number,
    fileInUploadProgressId: string,
    cancelTokenSource: CancelTokenSource,
    agreementAcceptedDateKey?: string,
    groupId?: string
  ) =>
    postMultipart<EnrollmentApplication>(
      `${enrollmentFileUploadRootUri}/EnrollmentFileOrchestrator/${addFilterParameters({
        templateId: applicationTypeId,
        agreementAcceptedDateKey,
        groupId,
        fileName: file.name,
        fileInUploadProgressId,
      })}`,
      file,
      cancelTokenSource.token
    ),

  uploadEmployerProfiles: (file: File) =>
    postMultipart<EnrollmentApplication>(
      `${enrollmentFileUploadRootUri}/EmployerProfileUploadOrchestrator/${addFilterParameters({
        fileName: file.name,
      })}`,
      file
    ),

    getEnrollmentApplications: (filter?: EnrollmentApplicationsFilters, sort?: Sort) =>
    withCancellation(cancelToken =>
      enrollmentFileHistoryApi
        .enrollmentFilesHistoryGet('1', {
          params: {...filter, ...(sort && toSortQuerystringParams(sort))},
          ...getAxiosConfig(cancelToken, false),
        })
        .then(handleResponse)
        .then(value => value as AsyncResult<Page<EnrollmentApplication>>)
    ),



  getEmployerProfileUploadDetails: (filter?: EmployerProfileUploadFilters, sort?: Sort) =>
    withCancellation(cancelToken =>
      employerProfileHistoryApi
        .employerProfileHistoryGet('1', {
          params: {...filter, ...(sort && toSortQuerystringParams(sort))},
          ...getAxiosConfig(cancelToken, false),
        })
        .then(handleResponse)
        .then(value => value as AsyncResult<Page<EmployerProfileDetails>>)
    ),

  getExternalUploadQueue: (filter?: ExternalUploadQueueFilters) =>
    get<Page<ExternalUploadEnrollmentApplication>>(
      `${enrollmentFileRootUri}/externalUploadQueue/${addFilterParameters(filter)}`
    ),

  getEnrollmentApplicationsDetail: (id: string) =>
    get<EnrollmentApplication[]>(`${enrollmentFileRootUri}/${id}/details`),

  getEnrollmentFileErrorDetails: (filter?: EnrollmentApplicationErrorDetailFilters, sort?: Sort) =>
    withCancellation(cancelToken =>
      enrollmentFileHistoryApi
        .enrollmentFilesHistoryGetEnrollmentFileErrorDetails('1', {
          params: {...filter, ...(sort && toSortQuerystringParams(sort))},
          ...getAxiosConfig(cancelToken, false),
        })
        .then(handleResponse)
        .then(value => value as AsyncResult<Page<EnrollmentFileErrorDetails>>)
    ),

  getAllowedEnrollmentApplicationTemplates: () =>
    get<EnrollmentApplicationTemplate[]>(`${documentsRootUri}/applications/templates`),

  getEnrollmentFileAWDHistoryDetail: (id: string) =>
    get<AWDHistoryDetail>(`${enrollmentFileAWDHistoryRootUri}/${id}/details`),
  saveAgreementAcknowledgment: () => post<AgreementAcknowledgment>(`${documentsRootUri}/upload/acknowledge`),

  updateEnrollmentFileAuditStatus: (fileId: string) => post<string>(`${enrollmentFileRootUri}/${fileId}/audit`),

  updateEnrollmentFileRejectDetails: (caseRequestId: string, deleteReason?: number) =>
    post<string>(
      `${enrollmentFileRootUri}/processingHistory/rejects/${addFilterParameters({
        caseRequestId,
        deleteReason,
      })}`
    ),

  getEnrollments: (filter?: EmployerEnrollmentFilters) =>
    withCancellation(cancelToken =>
      enrollmentApi
        .searchEmployerEnrollments('1', {params: filter, ...getAxiosConfig(cancelToken, false)})
        .then(handleResponse)
        .then(value => value as AsyncResult<Page<EmployerEnrollment>>)
    ),

  getEnrollmentDetails: (filter?: EmployerEnrollmentFilters) =>
    withCancellation(cancelToken =>
      enrollmentDetailsApi
        .getEnrollmentDiscrepancyDetail('1', {params: filter, ...getAxiosConfig(cancelToken, false)})
        .then(handleResponse)
        .then(value => value as AsyncResult<Page<EmployerEnrollmentDetails>>)
    ),

  getEnrollmentFileAuditDetail: (fileId: string) =>
    get<EnrollmentFileAuditDetail>(`${enrollmentFileRootUri}/${fileId}/auditdetail`),

  getEnrollmentFileRecordValidationResult: (fileId: string) =>
    get<EnrollmentFileRecordValidationResult>(`${enrollmentFileRootUri}/${fileId}/recordValidation`),

  getLifeCycleReportChartDetail: (chartType: string) =>
    get<LifeCycleReportChartDetailsPayload>(
      `${enrollmentFileRootUri}/lifeCycleReport/esr/chartDetails?chartType=${chartType}`
    ),

  getProcessingAccuracyChartDetails: (
    employerName?: string,
    agentNumbers?: string,
    isNewYork?: boolean,
    encryptedIdentifier?: string,
    caseNumbers?: string,
    productType?: string,
    startdate?: string,
    endDate?: string
  ) =>
    get<ProcessingAccuracyChartDetailsPayload[]>(
      `${enrollmentFileRootUri}/enrollmentStatus/${addFilterParameters({
        employerName,
        agentNumbers,
        isNewYork,
        encryptedIdentifier,
        caseNumbers,
        productType,
        startdate,
        endDate,
      })}`
    ),

  getDaysToCompleteTurnAroundChartDetails: () =>
    get<DaysToCompleteTurnAroundChartDetailsPayload[]>(
      `${enrollmentFileRootUri}/daysToCompleteTurnAroundChart/esr/chartDetails`
    ),

  getTotalRecordsChartDetails: () =>
    get<TotalRecordsChartDetailsPayload[]>(`${enrollmentFileRootUri}/totalRecordsChart/esr/chartDetails`),

  getFileVolumChartDetails: (chartType: string, employerName?: string) =>
    get<LifeCycleReportChartDetailsPayload>(
      `${enrollmentFileRootUri}/esrCharts/lifeCycleReport/chartDetails/${addFilterParameters({
        chartType,
        employerName,
      })}`
    ),

  getEsrTotalRecordsChartDetails: (employerName?: string) =>
    get<TotalRecordsChartDetailsPayload[]>(
      `${enrollmentFileRootUri}/esrCharts/totalRecords/chartDetails/${addFilterParameters({employerName})}`
    ),

  getEmployers: () => get<Employer[]>(`${enrollmentFileRootUri}/employers/allEmployers`),

  updateEnrollmentFileStatus: (fileId: string, fileStatusId?: number, removalReasonId?: number, returnComments?: string, uploadedByEmail?: string, actionBy?: string) =>
    post<string>(
      `${enrollmentFileRootUri}/updateStatus/${addFilterParameters({
        fileId,
        fileStatusId,
        removalReasonId,
        returnComments,
        uploadedByEmail,
        actionBy,
      })}`
    ),

  updateBrokerSpreadsheetCancelStatus: (fileId: string, fileStatusId?: number, removalReasonId?: number) =>
    post<string>(
      `${enrollmentFileRootUri}/cancelStatus/${addFilterParameters({
        fileId,
        fileStatusId,
        removalReasonId,
      })}`
    ),

  getFileUploadsInProgress: () => get<FileUploadInProgress[]>(`${documentsRootUri}/upload/inProgress`),

  getBrokerSpreadsheetUploadsMetrics: () =>
    get<BrokerSpreadsheetUploadsMetrics>(`${enrollmentFileRootUri}/brokerspreadsheetuploads/metrics`),

  getApplications: (filter?: ApplicationsFilter, sort?: Sort) =>
    withCancellation(cancelToken =>
      enrollmentFileHistoryApi
        .enrollmentFilesHistoryGetEnrollmentFileApplications('1', {
          params: {...filter, ...(sort && toSortQuerystringParams(sort))},
          ...getAxiosConfig(cancelToken, false),
        })
        .then(handleResponse)
        .then(value => value as AsyncResult<Page<Application>>)
    ),

    getGenelcoBatchFile: (filter?: GenelcoBatchFileFilters, sort?: Sort) =>
    withCancellation(cancelToken =>
      genelcoBatchFileApi
        .genelcoBatchFileGet('1', {
          params: {...filter, ...(sort && toSortQuerystringParams(sort))},
          ...getAxiosConfig(cancelToken, false),
        })
        .then(handleResponse)
        .then(value => value as AsyncResult<Page<GenelcoBatchFile>>)
    ),

  reGenerateBatchFile: (processingCompletedDate?: Date) =>
    post<GenelcoBatchFileCommand>(
      `${enrollmentFileRootUri}/reGenerateBatchFile/${addFilterParameters({
        processingCompletedDate: processingCompletedDate,
      })}`
    ),

  reAuditBatchFile: (processingCompletedDate?: Date) =>
    post<GenelcoBatchFileCommand>(
      `${enrollmentFileRootUri}/reAuditBatchFile/${addFilterParameters({
        processingCompletedDate: processingCompletedDate,
      })}`
    ),
  processBrokerSpreadsheet: (fileId: string, processReasonId?: number, actionBy?: string) => post(`${enrollmentFileRootUri}/startProcessing/${addFilterParameters({fileId, processReasonId, actionBy})}`),
  getAccountNumbers: () => get<any[]>(`${enrollmentFileRootUri}/getAllAccountNumber`),
  getAllProduct: () => get<any[]>(`${enrollmentFileRootUri}/geAllProductType`),
  getExternalUploadDetailsQueue: (fileId: string, filter?: ExternalUploadQueueDetailsFilters, column?: string, direction?: string) =>
  get<Page<ExternalUploadEnrollmentApplicationDetails>>(
    `${enrollmentFileRootUri}/${fileId}/externalUploadQueueDetails/${addFilterParameters(filter)}&sortColumn=${column}&sortOrder=${direction}`
  ),
  };
